import React, { useState } from "react";
import "./ShareButton.scss";

const ShareButton: React.FC<{
  showId: string;
}> = (props): JSX.Element => {
  const [copied, setCopied] = useState(false);

  const handleClick = () => {
    const shareUrl = `https://share.deadhead.live/show/${props.showId}`;
    navigator.clipboard.writeText(shareUrl).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <div
      className={`ShareButton ui button compact tiny basic ${
        copied ? "teal" : "secondary"
      }`}
      tabIndex={0}
      onClick={handleClick}
    >
      {copied ? (
        <>
          <i className="check icon" />
          Copied
        </>
      ) : (
        <>
          <i className="share icon" />
          Share
        </>
      )}
    </div>
  );
};

export default ShareButton;
